const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Freight Settings',
  description: 'Related to freight workings',
  sortOrder: 1,
  name: 'freight_settings',
  documentKey: 'freight_settings',
  values: {
    capacity: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'weight',
      displayName: 'Capacity',
      documentKey: 'capacity',
    },
    distance: {
      dataType: NIMBUS_DATA_TYPES.INTEGER,
      defaultValue: 1,
      displayName: 'Distance',
      documentKey: 'distance',
    },
  },
};
